import { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface DeleteStorageContainerMutation {
  deleteStorageContainer: boolean
}

export interface DeleteStorageContainerVariables {
  id: GQL_ID
}

export const GQL_MUTATION_DELETE_STORAGE_CONTAINER = gql`
  mutation deleteStorageContainer($id: ID!) {
    deleteStorageContainer(id: $id)
  }
`

export function useDeleteStorageContainer () {
  return useMutation<DeleteStorageContainerMutation, DeleteStorageContainerVariables>(
    GQL_MUTATION_DELETE_STORAGE_CONTAINER
  )
}
